import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=0490aa17&scoped=true&"
import script from "./BoardList.vue?vue&type=script&lang=js&"
export * from "./BoardList.vue?vue&type=script&lang=js&"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=0490aa17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490aa17",
  null
  
)

export default component.exports